import { Box, Typography } from '@mui/material';
import TranslationContainer from '@/features/translation/components/TranslationContainer';

export default function TranslationPage() {
  return (
    <Box>
      <Typography variant="h4" fontWeight={600} gutterBottom>
        Nueva Traducción
      </Typography>
      <TranslationContainer />
    </Box>
  );
}
